










































































import { Component, mixins, Prop } from 'nuxt-property-decorator'
import 'swiper/swiper.scss'
import { Swiper, Pagination, Zoom } from 'swiper'
import { SwiperOptions } from 'swiper/types'
import { Capacitor } from '@capacitor/core'
import { mdiCameraPlus } from '@mdi/js'
import { IImageMeta, IImageVariants } from '~/assets/interfaces/images'
import { PRODUCTS_API } from '~/assets/config/api-path'
import { IVideoItem } from '~/assets/interfaces/video'
import MixinGeneral from '~/assets/mixins/general'
import ComponentVideoButton from '~/components/video/video-button.vue'
import ComponentImage from '~/components/images/image.vue'
import ComponentIcon from '~/components/icon/icon.vue'
import ComponentVideo from '~/components/video/video.vue'

interface IImageGalleryItem {
  image: IImageVariants[]
  imageLarge: IImageVariants[]
  lazyLoad?: string
  isUserPhoto?: boolean
  meta?: IImageMeta
}

Swiper.use([Pagination])
Swiper.use([Zoom])

@Component({
  components: {
    ComponentImage,
    ComponentIcon,
    ComponentImageUploadPhotoForm: () =>
      import('~/components/images/upload-photo-form.vue'),
    ComponentPopup: () => import('~/components/popup/popup.vue'),
    ComponentVideo,
    ComponentVideoButton,
  },
})
export default class ComponentMobileImageGallery extends mixins(MixinGeneral) {
  @Prop({ type: Number, default: -1 }) readonly productId!: number
  @Prop({ default: false, type: Boolean }) readonly canUpload!: boolean
  @Prop({ default: false, type: Boolean }) readonly hasVideo!: boolean
  @Prop({ type: String, default: '1 / 1' }) readonly ratio!: string
  @Prop({ type: Boolean, default: false }) readonly canZoom!: boolean
  @Prop({ type: Array, default: [] }) private items!: IImageGalleryItem[]

  private swiper!: Swiper
  private isCanUploadMounted = false

  private get styleImageWrapper() {
    let paddingTop =  ((1 / eval(this.ratio)) * 100); // eslint-disable-line
    if (paddingTop > 133) {
      paddingTop = 133
    }
    return {
      paddingTop: paddingTop.toString() + '%',
    }
  }

  private icons = {
    mdiCameraPlus,
  }

  private video: IVideoItem | null = null
  private isShowVideo = false
  private isShowUploadPhotoPopup = false

  private async created() {
    if (this.hasVideo) {
      this.video = await this.$axios.$get(
        PRODUCTS_API + '/' + this.productId + '/video'
      )
    }
  }

  private mounted(): void {
    const containerEl: HTMLElement = this.$refs.container as HTMLElement
    const paginationEl: HTMLElement = this.$refs.pagination as HTMLElement

    if (containerEl) {
      let options: SwiperOptions = {
        touchMoveStopPropagation: true,
        loop: !Capacitor.isNativePlatform,
      }

      if (this.canZoom) {
        options.zoom = true
      }

      if (paginationEl) {
        options = Object.assign(options, {
          pagination: {
            el: paginationEl,
            renderBullet(_index: number, className: string) {
              return '<button class="' + className + '"></button>'
            },
            bulletClass: this.$style.paginationItem,
            bulletActiveClass: this.$style.active,
            clickable: true,
          },
        })
      }
      this.swiper = new Swiper(containerEl, options)
    }
    this.isCanUploadMounted = this.canUpload
  }
}
